import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('../pages/HomePage.vue'),
  },
  {
    path: '/games',
    name: 'games',
    component: () => import('../pages/GameListPage.vue'),
  },
  {
    path: '/games/:slug',
    name: 'game-detail',
    component: () => import('../pages/GameDetailPage.vue'),
    props: true,
  },
  {
    path: '/play/:slug',
    name: 'game-play',
    component: () => import('../pages/GamePlayPage.vue'),
    props: true,
  },
  {
    path: '/ranks',
    name: 'ranks',
    component: () => import('../pages/RanksPage.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../pages/AboutPage.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../pages/LoginPage.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../pages/RegisterPage.vue'),
  },
  {
    path: '/me',
    name: 'profile',
    component: () => import('../pages/ProfilePage.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../pages/NotFoundPage.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router
